let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("gctwz"), load("7f9Fz"), load("ffEVr"), load("lhkXg")]).then(() => parcelRequire('hLSQl'));